import React from "react";
import PropTypes from "prop-types";

function SimpleUploadLink(props) {
  const { labelText, name, disable } = props;
  let style = {
    cursor: "pointer",
    border: "1px solid #0084bf",
    color: "#0084bf",
    backgroundColor: "#fff",
    textTransform: "none",
    fontWeight: "bold",
    width: 150,
    borderRadius: 4,
    padding: "10px 13px"
  };
  if (disable) style = {};
  return (
    <React.Fragment>
      <input
        style={{ display: "none" }}
        disabled={disable}
        type="file"
        {...props}
      />
      <label htmlFor={name} style={style}>
        {labelText}
      </label>
    </React.Fragment>
  );
}
SimpleUploadLink.propTypes = {
  name: PropTypes.string.isRequired,
  labelText: PropTypes.string.isRequired,
  disable: PropTypes.bool,
};
export default SimpleUploadLink;
